/* Estocar — comportamento do tema (sem dependências).
   Segurança: nenhum dado do cliente vai para URL de analytics; texto sempre via textContent; localStorage em try/catch.
   Veículo salvo: { marca, modelo, ano, versao, geracao } em localStorage "estocar_veiculo" (geracao desde a Fase 3;
   veículo salvo antes dela não tem geração e, quando o ano tiver mais de uma, a peça fica "a confirmar"). */
(function () {
  'use strict';
  var CHAVE = 'estocar_veiculo';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function norm(t) {
    return String(t == null ? '' : t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function handle(t) { return norm(t).replace(/ /g, '-'); }

  /* ---------- veículo salvo ---------- */
  var Veiculo = {
    ler: function () {
      try { var v = JSON.parse(localStorage.getItem(CHAVE) || 'null'); return v && v.marca && v.modelo ? v : null; } catch (e) { return null; }
    },
    salvar: function (v) {
      try { localStorage.setItem(CHAVE, JSON.stringify(v)); } catch (e) { /* navegação privada: segue sem salvar */ }
      document.dispatchEvent(new CustomEvent('estocar:veiculo', { detail: v }));
    },
    limpar: function () {
      try { localStorage.removeItem(CHAVE); } catch (e) {}
      document.dispatchEvent(new CustomEvent('estocar:veiculo', { detail: null }));
    },
    nome: function (v) { return v ? [v.marca, v.modelo, v.ano].filter(Boolean).join(' ') + (v.geracao ? ' (' + v.geracao + ')' : '') : ''; }
  };
  window.EstocarVeiculo = Veiculo;

  /* ---------- compatibilidade peça × veículo (regra única: cards, filtro, página do produto) ----------
     Fase 3 (01/11/2026). Cada aplicação cadastrada (custom.aplicacoes) é avaliada INTEIRA.
     a) Linha com período em MESES (de_mes/ate_mes "AAAA-MM", catálogo BMW por código): o período é de FABRICAÇÃO.
        O ano escolhido pelo comprador pode ser o ano-modelo; por isso o ano Y cobre fabricação de 07/(Y-1) a 12/Y.
        As gerações (séries) do modelo fabricadas nessa janela vêm da tabela documental snippets/estocar-geracoes
        (RealOEM). Só há 'sim' quando TODAS as gerações possíveis (ou a geração escolhida) estão cobertas, na janela
        inteira, por linhas sem restrição. Cobertura parcial, geração indefinida ou linha com "confirmar" = 'confirmar'.
     b) Linha só com anos (de/ate, listas do titular): regra anterior (ano dentro do período; versão quando houver).
     Resultado: { s: 'sim'|'confirmar'|'nao'|null, falta: 'ano'|'versao'|'geracao'|'mes'|'restricao'|null, det: texto }.
     null = sem veículo ou peça sem aplicação (ausência não é compatibilidade nem incompatibilidade). Universal só com
     marcação explícita (tag aplicacao-universal), nunca por título/código. */
  function listaAplic(x) {
    /* linha sem modelo não é aplicação (dado malformado = sem dado, nunca 'não serve') */
    return Array.isArray(x) ? x.filter(function (a) { return a && typeof a === 'object' && !Array.isArray(a) && a.modelo; }) : [];
  }
  /* versão da aplicação ("R 1200 GS Adv.") contra a versão escolhida ("R 1200 GS Adventure 1170cc"):
     palavras inteiras e em sequência; palavra terminada em ponto é abreviação (prefixo). */
  function versaoConfere(av, vv) {
    var brutas = String(av).trim().split(/\s+/);
    var a = brutas.map(function (t) { return norm(t).replace(/ /g, ''); });
    var abrev = brutas.map(function (t) { return /\.$/.test(t); });
    var v = norm(vv).split(' ').filter(Boolean);
    if (!a.length || !a[0]) return false;
    for (var i = 0; i + a.length <= v.length; i++) {
      var ok = true;
      for (var k = 0; k < a.length && ok; k++) ok = v[i + k] === a[k] || (abrev[k] && v[i + k].indexOf(a[k]) === 0);
      if (ok) return true;
    }
    return false;
  }
  function mesNum(s) { var m = /^(\d{4})-(\d{2})$/.exec(String(s || '')); return m ? (+m[1]) * 12 + (+m[2] - 1) : null; }
  function mesTxt(n) { return ('0' + (n % 12 + 1)).slice(-2) + '/' + Math.floor(n / 12); }
  var GER = null;
  /* tabela documental: { "marca|modelo": [[geracao, versao, de_mes, ate_mes], ...] } (chaves normalizadas) */
  function tabelaGeracoes() {
    if (GER) return GER;
    try { var el = document.getElementById('es-geracoes'); GER = el ? JSON.parse(el.textContent) : {}; } catch (e) { GER = {}; }
    return GER;
  }
  function janelaAno(ano) { return [(ano - 1) * 12 + 6, ano * 12 + 11]; }
  /* gerações possíveis do veículo escolhido na janela do ano (versão e geração escolhidas filtram) */
  function geracoesPossiveis(marca, modelo, v, ano, linhas) {
    var tab = tabelaGeracoes()[norm(marca) + '|' + norm(modelo)];
    var jan = janelaAno(ano), out = [];
    if (!tab || !tab.length) {
      /* modelo fora da tabela: usa as séries das próprias linhas (sem saber se existe outra geração = nunca afirma) */
      tab = []; var vistos = {};
      linhas.forEach(function (a) { var k = (a.geracao || '') + '|' + (a.versao || ''); if (!vistos[k]) { vistos[k] = 1; tab.push([a.geracao || '', a.versao || '', a.de_mes, a.ate_mes, 1]); } });
    }
    var comVersao = tab.filter(function (g) { return g[1] && v.versao && versaoConfere(g[1], v.versao); });
    var base = v.versao && comVersao.length ? comVersao : tab.filter(function (g) { return !g[1]; });
    base.forEach(function (g) {
      var d = mesNum(g[2]), t = mesNum(g[3]);
      if (d == null || t == null || t < jan[0] || d > jan[1]) return;
      if (v.geracao && norm(g[0]) !== norm(v.geracao)) return;
      out.push({ ger: g[0], versao: g[1] || '', de: Math.max(d, jan[0]), ate: Math.min(t, jan[1]), gde: d, gate: t, semTabela: !!g[4] });
    });
    return out;
  }
  function avaliarMeses(linhas, v, ano) {
    var cands = geracoesPossiveis(linhas[0].marca, linhas[0].modelo, v, ano, linhas);
    var jan = janelaAno(ano);
    if (!cands.length) {
      /* só linhas de outra versão (ex.: Adventure) cruzam o ano: falta a versão */
      var outraVersao = linhas.some(function (a) { var d = mesNum(a.de_mes), t = mesNum(a.ate_mes); return a.versao && !v.versao && d <= jan[1] && t >= jan[0]; });
      return outraVersao ? { s: 'confirmar', falta: 'versao', det: '' } : { s: 'nao', falta: null, det: '' };
    }
    var cobre = 0, parcial = [], restr = [], semCobertura = [];
    cands.forEach(function (c) {
      var ok = false, toca = false;
      linhas.forEach(function (a) {
        if (norm(a.geracao || '') !== norm(c.ger) || norm(a.versao || '') !== norm(c.versao)) return;
        var d = mesNum(a.de_mes), t = mesNum(a.ate_mes);
        if (d == null || t == null || t < c.de || d > c.ate) return;
        toca = true;
        if (a.confirmar) { restr.push(String(a.confirmar)); return; }
        if (d <= c.de && t >= c.ate) ok = true;
        else parcial.push((c.ger ? c.ger + ': ' : '') + 'fabricação de ' + mesTxt(d) + ' a ' + mesTxt(t));
      });
      if (ok && !c.semTabela) cobre++;
      else if (!toca) semCobertura.push(c.ger);
    });
    if (cobre === cands.length) return { s: 'sim', falta: null, det: '' };
    var algum = cobre || parcial.length || restr.length || cands.some(function (c) { return c.semTabela; });
    if (!algum) return { s: 'nao', falta: null, det: '' };
    if (cands.length > 1 && !v.geracao && (semCobertura.length || cobre < cands.length)) {
      return { s: 'confirmar', falta: 'geracao', det: 'Em ' + ano + ' houve mais de uma geração deste modelo (' + cands.map(function (c) { return c.ger; }).join(', ') + ').' };
    }
    if (restr.length) return { s: 'confirmar', falta: 'restricao', det: restr[0] };
    if (parcial.length) return { s: 'confirmar', falta: 'mes', det: 'No catálogo BMW, esta peça vale para ' + parcial[0] + '.' };
    return { s: 'confirmar', falta: 'restricao', det: 'O catálogo BMW indica a série, mas não confirma todas as versões dela.' };
  }
  function avaliar(aplicacoes, v, fornecedor, universal) {
    var lista = listaAplic(aplicacoes);
    if (!v) return { s: null, falta: null, det: '' };
    if (universal === true) return { s: 'sim', falta: null, det: '' };
    if (!lista.length) return { s: null, falta: null, det: '' };
    var falta = null, conf = false, ano = parseInt(v.ano, 10), meses = [];
    for (var i = 0; i < lista.length; i++) {
      var a = lista[i];
      var marcaA = a.marca || fornecedor;
      if (!marcaA || norm(marcaA) !== norm(v.marca)) continue;
      if (!a.modelo || norm(a.modelo) !== norm(v.modelo)) continue;
      if (a.de_mes && a.ate_mes) { meses.push({ marca: marcaA, modelo: a.modelo, versao: a.versao, geracao: a.geracao, de_mes: a.de_mes, ate_mes: a.ate_mes, confirmar: a.confirmar }); continue; }
      var de = parseInt(a.de, 10), ate = parseInt(a.ate, 10);
      if (!de && !ate) { conf = true; continue; }
      if (!ano) { conf = true; falta = falta || 'ano'; continue; }
      if ((de && ano < de) || (ate && ano > ate)) continue;
      if (a.confirmar) { conf = true; falta = falta || 'restricao'; continue; }
      if (a.versao) {
        if (v.versao && versaoConfere(a.versao, v.versao)) return { s: 'sim', falta: null, det: '' };
        conf = true; if (!v.versao) falta = falta || 'versao';
        continue;
      }
      return { s: 'sim', falta: null, det: '' };
    }
    if (meses.length) {
      if (!ano) return { s: 'confirmar', falta: 'ano', det: '' };
      var r = avaliarMeses(meses, v, ano);
      if (r.s !== 'nao') return r;
    }
    return { s: conf ? 'confirmar' : 'nao', falta: falta, det: '' };
  }
  function frase(t) { t = String(t || '').trim(); return t ? t.charAt(0).toUpperCase() + t.slice(1) + (/[.!?]$/.test(t) ? '' : '.') + ' ' : ''; }
  function textoFalta(r) {
    if (r.falta === 'ano') return 'Escolha o ano do seu veículo para confirmar.';
    if (r.falta === 'versao') return 'Escolha a versão do seu veículo para confirmar.';
    if (r.falta === 'geracao') return frase(r.det) + 'Escolha a geração no seletor ou confirme pelo chassi (VIN).';
    if (r.falta === 'mes') return frase(r.det) + 'Confira o mês de fabricação no documento do veículo ou pelo chassi (VIN).';
    if (r.falta === 'restricao') return frase(r.det) + 'Informe o chassi (VIN) para confirmarmos.';
    return 'O período ou a versão desta aplicação ainda precisa ser confirmado.';
  }
  window.EstocarCompat = { avaliar: avaliar, geracoesPossiveis: geracoesPossiveis, textoFalta: textoFalta };
  /* data-es-aplic pode trazer "null" (produto sem aplicação), "[]" ou JSON malformado: sempre devolve lista */
  function lerAplic(el) {
    var bruto = el.getAttribute('data-es-aplic');
    if (!bruto) return [];
    try { return listaAplic(JSON.parse(bruto)); } catch (e) { return []; }
  }

  /* ---------- busca por código: "34 10 6 860 019" → "34106860019"; "52950-2G000" → "529502G000"; mantém sufixo "-BI" ---------- */
  function normalizarCodigo(q) {
    var t = String(q || '').trim().toUpperCase().replace(/[\s.]+/g, '');
    var partes = t.split('-');
    if (partes.length > 1) {
      var ultimo = partes[partes.length - 1];
      var sufixo = /^[A-Z]{1,3}$/.test(ultimo) ? '-' + partes.pop() : '';
      t = partes.join('') + sufixo;
    }
    return t;
  }
  function pareceCodigo(q) {
    var t = String(q || '').trim();
    var digitos = (t.match(/\d/g) || []).length;
    /* código de peça não tem palavra: 4+ letras seguidas (ex.: "pastilha 3411...") = busca por texto */
    return digitos >= 5 && /^[\w\s.\-]+$/.test(t) && !/[a-zA-Z]{4,}/.test(t);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var campo = f.querySelector('input[name="q"]');
    if (!campo) return;
    var modoCodigo = f.hasAttribute('data-es-codigo');
    if (modoCodigo || pareceCodigo(campo.value)) {
      var n = normalizarCodigo(campo.value);
      if (n && n !== campo.value) campo.value = n;
    }
  }, true);

  /* ---------- seletor de veículo: SÓ veículos para os quais há peça publicada e disponível ----------
     Fonte: o mesmo índice leve do filtro (?view=es-indice), gerado ao vivo pelo Liquid a partir dos produtos
     PUBLICADOS na loja virtual (rascunho e não publicado não entram), com custom.aplicacoes e "disponível".
     Regra (montarArvore): cada linha de aplicação de um produto DISPONÍVEL gera, junta, marca → modelo → anos do
     período (de..ate) → versão da própria linha. Produto indisponível, sem aplicação ou universal não gera opção.
     Linha sem período não inventa anos (o modelo aparece, os anos não; fica "a confirmar"). A FIPE não acrescenta
     nada. Escopo "loja" = /collections/all; escopo "pagina" = coleção/busca atual (mesmos filtros da URL).
     Atualização: o índice reflete publicação, estoque e aplicação na hora (cache da vitrine Shopify); no navegador,
     a árvore da loja fica 10 min em sessionStorage e a da página 5 min em memória.
     A aplicação é do produto (custom.aplicacoes): "disponível" = alguma variante vendável. */
  var CHAVE_ARVORE = 'estocar_arvore_v3', TTL_ARVORE = 600000;
  function montarArvore(itens) {
    var arv = {};
    (itens || []).forEach(function (it) {
      /* it[6] = classe (snippets/estocar-classe-aplicacao): 'dispensa' nunca cria opção de veículo */
      if (!it || it[4] !== true || it[5] === true || it[6] === 'dispensa') return;
      listaAplic(it[3]).forEach(function (a) {
        var marca = String(a.marca || it[2] || '').trim(), modelo = String(a.modelo || '').trim();
        if (!marca || !modelo) return;
        var m = arv[marca] = arv[marca] || {};
        var f = m[modelo] = m[modelo] || { anos: {}, semPeriodo: false };
        var de = parseInt(a.de, 10), ate = parseInt(a.ate, 10);
        if (!de || !ate || ate < de || ate - de > 60) { f.semPeriodo = true; return; }
        for (var y = de; y <= ate; y++) {
          var ano = f.anos[y] = f.anos[y] || { versoes: {}, livre: false };
          if (a.versao) ano.versoes[String(a.versao).trim()] = 1; else ano.livre = true;
        }
      });
    });
    return arv;
  }
  window.EstocarSeletor = { montarArvore: montarArvore };
  function ordenarNomes(l) { return l.sort(function (a, b) { return a.localeCompare(b, 'pt-BR', { numeric: true }); }); }
  var Arvore = {
    memoria: {},
    carregar: function (escopo) {
      if (escopo === 'pagina' && Filtro.pagina()) {
        var ctx = Filtro.contexto(), chave = ctx.caminho + '?' + ctx.busca;
        if (Arvore.memoria[chave]) return Promise.resolve(Arvore.memoria[chave]);
        return Filtro.indice(ctx).then(function (itens) { return (Arvore.memoria[chave] = montarArvore(itens)); });
      }
      try {
        var s = JSON.parse(sessionStorage.getItem(CHAVE_ARVORE) || 'null');
        if (s && Date.now() - s.t < TTL_ARVORE && s.arv) return Promise.resolve(s.arv);
      } catch (e) {}
      return Filtro.indice({ caminho: raizLoja + 'collections/all', busca: '' }).then(function (itens) {
        var arv = montarArvore(itens);
        try { sessionStorage.setItem(CHAVE_ARVORE, JSON.stringify({ t: Date.now(), arv: arv })); } catch (e) {}
        return arv;
      });
    }
  };
  function opcoes(sel, itens, rotulo) {
    sel.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = rotulo; sel.appendChild(o);
    itens.forEach(function (i) { var op = document.createElement('option'); op.value = i; op.textContent = i; sel.appendChild(op); });
    sel.disabled = !itens.length;
  }
  function iniciarSeletor(raiz) {
    var sM = $('[data-es-campo="marca"]', raiz), sMo = $('[data-es-campo="modelo"]', raiz), sA = $('[data-es-campo="ano"]', raiz), sV = $('[data-es-campo="versao"]', raiz), sG = $('[data-es-campo="geracao"]', raiz);
    var caixaG = sG && sG.closest('[data-es-caixa-geracao]');
    function geracoes() {
      if (!sG) return;
      var ano = parseInt(sA.value, 10), lista = [];
      if (sM.value && sMo.value && ano) {
        lista = geracoesPossiveis(sM.value, sMo.value, { versao: sV && sV.value ? sV.value : null }, ano, []).filter(function (c) { return c.ger && !c.semTabela; });
      }
      sG.innerHTML = '';
      var o = document.createElement('option'); o.value = ''; o.textContent = lista.length > 1 ? 'Não sei a geração' : 'Geração'; sG.appendChild(o);
      if (lista.length > 1) lista.forEach(function (c) { var op = document.createElement('option'); op.value = c.ger; op.textContent = c.ger + ' — fabricada de ' + mesTxt(c.gde) + ' a ' + mesTxt(c.gate); sG.appendChild(op); });
      sG.disabled = lista.length < 2;
      if (caixaG) caixaG.hidden = lista.length < 2;
    }
    if (!sM || raiz.dataset.esPronto) return;
    raiz.dataset.esPronto = '1';
    var permitidas = (raiz.getAttribute('data-es-marcas') || '').split(',').map(function (m) { return norm(m); }).filter(Boolean);
    var arv = {};
    function familia() { return (arv[sM.value] || {})[sMo.value]; }
    /* trocar a opção de cima sempre limpa as de baixo (nada do modelo anterior sobrevive) */
    sM.onchange = function () {
      opcoes(sMo, ordenarNomes(Object.keys(arv[sM.value] || {})), 'Modelo');
      opcoes(sA, [], 'Ano'); if (sV) opcoes(sV, [], 'Versão'); geracoes();
    };
    sMo.onchange = function () {
      var f = familia();
      var anos = f ? Object.keys(f.anos).map(Number).sort(function (a, b) { return b - a; }).map(String) : [];
      opcoes(sA, anos, f && f.semPeriodo && !anos.length ? 'Ano: a confirmar' : 'Ano');
      if (sV) opcoes(sV, [], 'Versão');
      geracoes();
    };
    if (sV) sV.addEventListener('change', geracoes);
    sA.onchange = function () {
      if (!sV) { geracoes(); return; }
      var f = familia(), a = f && f.anos[sA.value];
      var vs = a ? ordenarNomes(Object.keys(a.versoes)) : [];
      opcoes(sV, vs, !vs.length ? 'Versão: não se aplica' : a.livre ? 'Versão (opcional)' : 'Versão (para confirmar)');
      geracoes();
    };
    function preencher(atual) {
      if (!atual || !arv[atual.marca]) return;
      sM.value = atual.marca; sM.onchange();
      if (!arv[atual.marca][atual.modelo]) return;
      sMo.value = atual.modelo; sMo.onchange();
      if (atual.ano && familia().anos[atual.ano]) { sA.value = String(atual.ano); sA.onchange(); if (sV && atual.versao) { sV.value = atual.versao; geracoes(); } if (sG && atual.geracao) sG.value = atual.geracao; }
    }
    raiz._esPreencher = function () { if (sM.disabled && !Object.keys(arv).length) return; sM.value = ''; sM.onchange(); preencher(Veiculo.ler()); };
    sM.disabled = true; sM.options[0].textContent = 'Carregando…';
    function carregar(tentativa) {
      Arvore.carregar(raiz.getAttribute('data-es-escopo') || 'loja').then(function (a) {
        arv = {};
        Object.keys(a).forEach(function (m) { if (!permitidas.length || permitidas.indexOf(norm(m)) > -1) arv[m] = a[m]; });
        var marcas = ordenarNomes(Object.keys(arv));
        opcoes(sM, marcas, marcas.length ? 'Marca' : 'Nenhum veículo com peças aqui');
        opcoes(sMo, [], 'Modelo'); opcoes(sA, [], 'Ano'); if (sV) opcoes(sV, [], 'Versão'); geracoes();
        preencher(Veiculo.ler());
      }).catch(function () {
        sM.disabled = true; sM.options[0].textContent = 'Lista de veículos indisponível';
        if (!tentativa) setTimeout(function () { carregar(1); }, 3000);
      });
    }
    /* Fase 4: seletor dentro de <details> fechado (produto, gaveta do filtro) só baixa a lista quando é aberto */
    var caixaDet = raiz.closest('details');
    if (caixaDet && !caixaDet.open) {
      sM.options[0].textContent = 'Marca';
      caixaDet.addEventListener('toggle', function abrir() { if (!caixaDet.open) return; caixaDet.removeEventListener('toggle', abrir); sM.options[0].textContent = 'Carregando…'; carregar(0); });
    } else carregar(0);
    var form = raiz.tagName === 'FORM' ? raiz : $('form', raiz);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!sM.value || !sMo.value) { (sM.value ? sMo : sM).focus(); return; }
      var v = { marca: sM.value, modelo: sMo.value, ano: sA.value ? parseInt(sA.value, 10) : null, versao: sV && sV.value ? sV.value : null, geracao: sG && !sG.disabled && sG.value ? sG.value : null };
      var destino = raiz.getAttribute('data-es-destino');
      if (destino !== 'ficar') Preferencia.salvar(true);
      if (destino === 'ficar' || destino === 'aqui') {
        if (destino === 'aqui') { definirParam('es_veiculo', '1'); definirParam('es_p', null); }
        Veiculo.salvar(v);
        var det = raiz.closest('details'); if (det && destino === 'aqui') det.open = false;
        return;
      }
      Veiculo.salvar(v);
      /* sem caminho de tag (/veiculo-marca-modelo): nenhum produto tem essa tag e a URL era redirecionada ao catálogo
         geral. O filtro roda sobre o conjunto completo da coleção (índice leve), então basta a coleção. */
      var base = (destino || '/collections/all').replace(/\/$/, '');
      if (base === location.pathname.replace(/\/$/, '')) { definirParam('es_veiculo', '1'); definirParam('es_p', null); Filtro.agendar(); return; }
      window.location.href = base + '?es_veiculo=1';
    });
  }

  /* ---------- trocar e remover veículo ----------
     Sincronização URL × seleção: o veículo vive só em localStorage (estocar_veiculo); a URL leva só o modo do filtro
     (es_veiculo) e a página filtrada (es_p). Link que escolhe um veículo de propósito usa
     ?es_marca=&es_modelo=&es_ano=&es_versao=: o veículo é salvo na chegada e esses parâmetros saem da URL.
     Remover = apaga o veículo e a preferência do filtro, tira es_veiculo/es_p/es_marca… da URL (os demais ficam:
     q, sort_by, filter.*), devolve a grade original e invalida respostas pendentes (Filtro.seq). */
  var PARAMS_VEICULO = ['es_veiculo', 'es_p', 'es_marca', 'es_modelo', 'es_ano', 'es_versao', 'es_geracao'];
  function veiculoDaUrl() {
    var p = new URLSearchParams(location.search);
    var marca = p.get('es_marca'), modelo = p.get('es_modelo');
    if (!marca || !modelo) return;
    var ano = parseInt(p.get('es_ano'), 10) || null, versao = p.get('es_versao') || null, geracao = p.get('es_geracao') || null;
    ['es_marca', 'es_modelo', 'es_ano', 'es_versao', 'es_geracao'].forEach(function (k) { definirParam(k, null); });
    if (!lerParam('es_veiculo')) definirParam('es_veiculo', '1');
    Preferencia.salvar(true);
    try { localStorage.setItem(CHAVE, JSON.stringify({ marca: marca.slice(0, 60), modelo: modelo.slice(0, 80), ano: ano, versao: versao ? versao.slice(0, 120) : null, geracao: geracao ? geracao.slice(0, 20) : null })); } catch (e) {}
  }
  function anunciar(txt) {
    var r = document.getElementById('es-anuncio');
    if (!r) { r = document.createElement('div'); r.id = 'es-anuncio'; r.className = 'es-vh'; r.setAttribute('role', 'status'); r.setAttribute('aria-live', 'polite'); document.body.appendChild(r); }
    r.textContent = ''; setTimeout(function () { r.textContent = txt; }, 50);
  }
  function removerVeiculo(botao) {
    var secao = (botao && botao.closest('.shopify-section')) || document;
    Preferencia.salvar(false);
    PARAMS_VEICULO.forEach(function (k) { definirParam(k, null); });
    Veiculo.limpar();
    $$('[data-es-seletor]').forEach(function (s) { if (s._esPreencher) s._esPreencher(); });
    var alvo = $('[data-es-seletor] [data-es-campo="marca"]', secao);
    if (alvo && alvo.offsetParent !== null) alvo.focus();
    anunciar('Veículo removido. Mostrando todas as peças.');
  }
  function trocarVeiculo(botao) {
    var secao = (botao && botao.closest('.shopify-section')) || document;
    var sel = $('[data-es-seletor]', secao) || $('[data-es-seletor]');
    if (!sel) { window.location.href = raizLoja; return; }
    var det = sel.closest('details'); if (det) { det.hidden = false; det.open = true; }
    var campo = $('[data-es-campo="marca"]', sel);
    sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (campo) setTimeout(function () { campo.focus(); }, 250);
  }

  /* ---------- preferência "Mostrar só o que serve" (regra única) ----------
     A URL manda (es_veiculo=1 liga, es_veiculo=0 desliga). Sem o parâmetro, vale a última escolha do cliente neste
     navegador, para que a escolha acompanhe a troca de coleção, a busca e a remoção de filtros. */
  var CHAVE_FILTRO = 'estocar_filtro_veiculo';
  var Preferencia = {
    ler: function () {
      var m = location.search.match(/[?&]es_veiculo=([01])(?:&|$)/);
      if (m) return m[1] === '1';
      try { return localStorage.getItem(CHAVE_FILTRO) === '1'; } catch (e) { return false; }
    },
    salvar: function (ligado) { try { localStorage.setItem(CHAVE_FILTRO, ligado ? '1' : '0'); } catch (e) {} }
  };
  function lerParam(nome) { return new URLSearchParams(location.search).get(nome); }
  function definirParam(nome, valor, empilhar) {
    var p = new URLSearchParams(location.search);
    if (valor == null) p.delete(nome); else p.set(nome, valor);
    var q = p.toString();
    var url = location.pathname + (q ? '?' + q : '') + location.hash;
    if (empilhar) history.pushState({ esFiltro: true }, '', url); else history.replaceState(history.state, '', url);
  }

  /* ---------- selos "serve no seu veículo" nos cards e filtro na coleção ---------- */
  function textoSelo(r, v) {
    var curto = v.modelo + (v.ano ? ' ' + v.ano : '');
    if (r.s === 'sim') return '✓ Serve no seu ' + curto;
    if (r.s === 'confirmar') return r.falta === 'ano' ? 'Informe o ano para confirmar' : r.falta === 'versao' ? 'Informe a versão para confirmar' : r.falta === 'geracao' ? 'Informe a geração para confirmar' : 'Aplicação a confirmar';
    if (r.s === 'nao') return 'Não indicada para o seu ' + curto;
    return '';
  }
  function atualizarCards() {
    var v = Veiculo.ler();
    $$('[data-es-aplic]').forEach(function (el) {
      var dispensa = el.getAttribute('data-es-classe') === 'dispensa';
      var r = dispensa ? { s: null, falta: null } : avaliar(lerAplic(el), v, el.getAttribute('data-es-fornecedor'), el.hasAttribute('data-es-universal'));
      var selo = $('.es-card-serve', el);
      if (selo) {
        var txt = r.s ? textoSelo(r, v) : '';
        selo.hidden = !txt;
        if (selo.textContent !== txt) selo.textContent = txt;
        selo.classList.toggle('es-selo--ok', r.s === 'sim');
        selo.classList.toggle('es-selo--aviso', r.s === 'confirmar');
        selo.classList.toggle('es-selo--nao', r.s === 'nao');
      }
      el.setAttribute('data-es-serve', dispensa ? 'dispensa' : (r.s || 'sem-dado'));
    });
    var barra = $('[data-es-filtro-veiculo]');
    if (barra) {
      barra.hidden = !v;
      var nome = $('[data-es-nome-veiculo]', barra);
      if (nome) nome.textContent = Veiculo.nome(v);
      var chk = $('input[type="checkbox"]', barra);
      if (chk) chk.checked = !!(v && Preferencia.ler());
    }
    $$('[data-es-header-veiculo]').forEach(function (a) {
      a.hidden = !v;
      var t = $('[data-es-nome-veiculo]', a); if (t) t.textContent = Veiculo.nome(v);
    });
    $$('[data-es-so-com-veiculo]').forEach(function (b) { b.hidden = !v; });
    $$('[data-es-veiculo-salvo]').forEach(function (b) {
      b.hidden = !v;
      var t = $('[data-es-nome-veiculo]', b); if (t) t.textContent = Veiculo.nome(v);
    });
  }
  /* ---------- filtro "só o que serve" sobre o conjunto COMPLETO (coleção ou busca) ----------
     1) baixa o índice leve da própria listagem (?view=es-indice: id, handle, fornecedor, aplicações; sem imagem),
        com a mesma ordenação e os mesmos filtros da URL, em páginas de 250;
     2) avalia cada produto com avaliar(); 3) conta e pagina sobre o resultado; 4) busca só os cards da página
     visível (?view=es-card). O índice é gerado ao vivo pelo Liquid: quando o produto ou a aplicação muda, a próxima
     consulta já vem atualizada (cache de memória só durante a visita, 5 min). */
  var POR_PAGINA = 24, TTL = 300000, CONCORRENCIA = 6;
  var raizLoja = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var Filtro = {
    seq: 0, indices: {}, cards: {}, original: null, timer: null,
    agendar: function () { clearTimeout(Filtro.timer); Filtro.timer = setTimeout(Filtro.executar, 30); },
    pagina: function () { return !!($('[data-es-filtro-veiculo]') && document.getElementById('ProductGridContainer')); },
    /* 03/11: filtro por veículo e/ou por categoria (es_cat, só nas coleções de marca com o filtro Categoria) */
    veiculoAtivo: function () { return Filtro.pagina() && !!Veiculo.ler() && Preferencia.ler(); },
    categoria: function () { var c = lerParam('es_cat') || ''; return Categoria.presente() && Categoria.NOMES[c] ? c : ''; },
    ativo: function () { return Filtro.veiculoAtivo() || !!Filtro.categoria(); },
    contexto: function () {
      var p = new URLSearchParams(location.search);
      ['page', 'es_p', 'es_veiculo', 'es_cat', 'view', 'section_id', 'section_ids'].forEach(function (k) { p.delete(k); });
      return { caminho: location.pathname, busca: p.toString() };
    },
    executar: function () {
      var token = ++Filtro.seq;
      marcarFormularios();
      Categoria.sincronizar();
      var porVeiculo = Filtro.veiculoAtivo(), cat = Filtro.categoria();
      if (!Filtro.ativo()) {
        Filtro.restaurar();
        /* sem filtro ativo: só as contagens do filtro Categoria (conjunto completo da marca, com os demais filtros) */
        if (Categoria.presente()) Filtro.indice(Filtro.contexto()).then(function (itens) { if (token === Filtro.seq) Categoria.contar(itens, null); }).catch(function () {});
        return;
      }
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      if (!grid.hasAttribute('data-es-filtrado')) Filtro.salvarOriginal(grid);
      Filtro.estado('carregando');
      var v = porVeiculo ? Veiculo.ler() : null;
      Filtro.indice(Filtro.contexto()).then(function (itens) {
        if (token !== Filtro.seq) return null;
        Categoria.contar(itens, v);
        var sim = [], conf = 0, nao = 0, semDado = 0, dispensa = 0, naCat = 0;
        itens.forEach(function (it) {
          if (cat && (it[8] || []).indexOf(cat) === -1) return;
          naCat++;
          if (!v) { sim.push(it); return; }
          if (it[6] === 'dispensa') { dispensa++; return; }
          var r = avaliar(it[3], v, it[2], it[5] === true);
          if (r.s === 'sim') sim.push(it); else if (r.s === 'confirmar') conf++; else if (r.s === 'nao') nao++; else semDado++;
        });
        var paginas = Math.max(1, Math.ceil(sim.length / POR_PAGINA));
        var pag = parseInt(lerParam('es_p'), 10) || 1;
        if (pag < 1 || pag > paginas) { pag = Math.min(Math.max(pag, 1), paginas); definirParam('es_p', pag > 1 ? String(pag) : null); }
        var fatia = sim.slice((pag - 1) * POR_PAGINA, pag * POR_PAGINA);
        return Filtro.carregarCards(fatia).then(function (htmls) {
          if (token !== Filtro.seq) return;
          Filtro.desenhar({ v: v, cat: cat, total: naCat, sim: sim.length, conf: conf, semDado: semDado, dispensa: dispensa, pag: pag, paginas: paginas, htmls: htmls });
        });
      }).catch(function () {
        if (token !== Filtro.seq) return;
        Filtro.estado('erro');
      });
    },
    indice: function (ctx) {
      var chave = ctx.caminho + '?' + ctx.busca, c = Filtro.indices[chave];
      if (c && Date.now() - c.t < TTL) return Promise.resolve(c.itens);
      var url = function (n) { return ctx.caminho + '?' + (ctx.busca ? ctx.busca + '&' : '') + 'view=es-indice&page=' + n; };
      var ler = function (n) {
        /* sem cabeçalho Accept JSON: a Shopify trata como outro formato e responde 404 */
        /* Fase 4: resposta já pedida no <head> (mesma URL), usada uma vez */
        var u = url(n), pre = window.__esPre && window.__esPre[u];
        if (pre) delete window.__esPre[u];
        return (pre || fetch(u, { credentials: 'same-origin' })).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        }).then(function (d) {
          if (!d || d.v !== 1 || !Array.isArray(d.p)) throw new Error('índice inválido');
          return d;
        });
      };
      return ler(1).then(function (d1) {
        var resto = [];
        for (var n = 2; n <= d1.paginas; n++) resto.push(ler(n));
        return Promise.all(resto).then(function (ds) {
          var itens = d1.p.slice();
          ds.forEach(function (d) { itens = itens.concat(d.p); });
          Filtro.indices[chave] = { t: Date.now(), itens: itens };
          return itens;
        });
      });
    },
    carregarCards: function (fatia) {
      var res = new Array(fatia.length), i = 0;
      function proximo() {
        if (i >= fatia.length) return Promise.resolve();
        var k = i++, h = fatia[k][1];
        if (Filtro.cards[h]) { res[k] = Filtro.cards[h]; return proximo(); }
        return fetch(raizLoja + 'products/' + encodeURIComponent(h) + '?view=es-card', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (t) { if (t.indexOf('card-wrapper') === -1) throw new Error('card inválido'); Filtro.cards[h] = t; res[k] = t; return proximo(); });
      }
      var filas = [];
      for (var n = 0; n < Math.min(CONCORRENCIA, fatia.length); n++) filas.push(proximo());
      return Promise.all(filas).then(function () { return res; });
    },
    salvarOriginal: function (grid) {
      Filtro.original = {
        grid: grid,
        html: grid.innerHTML,
        contagens: $$('#ProductCount, #ProductCountDesktop').map(function (el) { return [el, el.innerHTML]; })
      };
    },
    paginacaoDawn: function () { var c = document.getElementById('ProductGridContainer'); return c ? $$('.pagination-wrapper', c) : []; },
    estado: function (qual) {
      var barra = $('[data-es-filtro-veiculo]');
      /* só categoria (sem veículo): mensagens próprias, sem falar em compatibilidade */
      var soCat = !Filtro.veiculoAtivo() && !!Filtro.categoria();
      if (soCat && (qual === 'carregando' || qual === 'vazio')) qual = qual + '-cat';
      $$('[data-es-filtro-estado]').forEach(function (el) { el.hidden = el.getAttribute('data-es-filtro-estado') !== qual; });
      var grid = document.getElementById('product-grid');
      if (grid) grid.setAttribute('aria-busy', qual === 'carregando' ? 'true' : 'false');
      var c = document.getElementById('ProductGridContainer');
      if (c) c.classList.toggle('es-filtro-carregando', qual === 'carregando');
      if (qual === 'carregando') $$('#ProductCount, #ProductCountDesktop').forEach(function (el) { el.textContent = 'Conferindo compatibilidade…'; });
      if (qual === 'carregando-cat') $$('#ProductCount, #ProductCountDesktop').forEach(function (el) { el.textContent = 'Filtrando por categoria…'; });
      if (qual === 'carregando-cat') { var cg = document.getElementById('ProductGridContainer'); if (cg) cg.classList.add('es-filtro-carregando'); }
      if (qual === 'erro') $$('#ProductCount, #ProductCountDesktop').forEach(function (el) { el.textContent = 'Compatibilidade não conferida'; });
      if (qual === 'erro') { var o = Filtro.original; if (o && o.grid.isConnected) { o.grid.style.display = 'none'; } Filtro.paginacaoDawn().forEach(function (p) { p.hidden = true; }); var nav = $('.es-paginacao'); if (nav) nav.remove(); }
      if (barra) barra.setAttribute('data-es-filtro-situacao', qual || '');
    },
    desenhar: function (r) {
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      grid.style.display = '';
      grid.setAttribute('data-es-filtrado', '1');
      grid.innerHTML = r.htmls.map(function (h) { return '<li class="grid__item">' + h + '</li>'; }).join('');
      Filtro.paginacaoDawn().forEach(function (p) { p.hidden = true; });
      var nome = Veiculo.nome(r.v), nCat = r.cat ? Categoria.NOMES[r.cat] : '';
      var txt = r.v ? (r.sim === 1 ? '1 peça serve no seu ' + nome : r.sim + ' peças servem no seu ' + nome) + (nCat ? ' em ' + nCat : '')
        : (r.sim === 1 ? '1 produto' : r.sim + ' produtos') + ' em ' + nCat;
      $$('#ProductCount, #ProductCountDesktop').forEach(function (el) { el.textContent = txt; });
      var resumo = $('[data-es-filtro-resumo]');
      if (resumo && !r.v) resumo.textContent = 'Categoria ' + nCat + ' nesta marca, com os demais filtros e a ordenação escolhidos.';
      if (resumo && r.v) {
        var partes = ['Aqui aparecem só as peças confirmadas para o seu ' + nome + ' pelas aplicações cadastradas'];
        if (r.conf) partes.push('outras dependem de geração, mês de fabricação ou versão: desmarque o filtro para vê-las ou fale com a Estocar pelo WhatsApp com o chassi (VIN)');
        if (r.dispensa) partes.push('roupas e acessórios que não dependem de veículo ficam fora deste filtro');
        resumo.textContent = partes.join('; ') + '.';
      }
      var vazioConf = $('[data-es-filtro-vazio-conf]');
      if (vazioConf) vazioConf.textContent = r.conf ? 'Há peças que podem servir, mas dependem de geração, mês de fabricação ou versão: desmarque o filtro para vê-las. ' : '';
      Filtro.estado(r.sim ? 'resultado' : 'vazio');
      if (!r.sim && !r.v) { var vc = $('[data-es-filtro-vazio-cat-nome]'); if (vc) vc.textContent = nCat; }
      Filtro.paginar(grid, r.pag, r.paginas);
      atualizarCards();
    },
    paginar: function (grid, pag, paginas) {
      var velha = $('.es-paginacao'); if (velha) velha.remove();
      if (paginas < 2) return;
      var nav = document.createElement('nav');
      nav.className = 'es-paginacao';
      nav.setAttribute('aria-label', Filtro.veiculoAtivo() ? 'Páginas das peças compatíveis' : 'Páginas dos produtos filtrados');
      var lista = document.createElement('ul');
      var item = function (n, rotulo, atual) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        var p = new URLSearchParams(location.search);
        if (n > 1) p.set('es_p', String(n)); else p.delete('es_p');
        a.href = location.pathname + '?' + p.toString();
        a.textContent = rotulo;
        a.setAttribute('data-es-pagina', String(n));
        if (atual) a.setAttribute('aria-current', 'page');
        if (rotulo !== String(n)) a.setAttribute('aria-label', rotulo === '‹' ? 'Página anterior' : 'Próxima página');
        li.appendChild(a); lista.appendChild(li);
      };
      if (pag > 1) item(pag - 1, '‹');
      for (var n = 1; n <= paginas; n++) item(n, String(n), n === pag);
      if (pag < paginas) item(pag + 1, '›');
      nav.appendChild(lista);
      grid.parentNode.insertBefore(nav, grid.nextSibling);
    },
    restaurar: function () {
      var o = Filtro.original;
      $$('[data-es-filtro-estado]').forEach(function (el) { el.hidden = true; });
      var nav = $('.es-paginacao'); if (nav) nav.remove();
      var c = document.getElementById('ProductGridContainer'); if (c) c.classList.remove('es-filtro-carregando');
      if (o && o.grid.isConnected) {
        o.grid.innerHTML = o.html;
        o.grid.style.display = '';
        o.grid.removeAttribute('data-es-filtrado');
        o.grid.setAttribute('aria-busy', 'false');
        o.contagens.forEach(function (par) { if (par[0].isConnected) par[0].innerHTML = par[1]; });
        Filtro.paginacaoDawn().forEach(function (p) { p.hidden = false; });
      }
      Filtro.original = null;
      atualizarCards();
    }
  };
  /* ---------- filtro Categoria nas coleções de marca (03/11/2026) ----------
     Classificação real do catálogo = coleções de categoria (freios, motor, …) e de Lifestyle (bmw-lifestyle,
     motorrad-lifestyle-rider), 9º campo do índice leve (snippets/estocar-indice-item). O filtro fica dentro dos
     formulários do Dawn (computador e gaveta do celular): mudar a categoria refaz a URL com es_cat e os demais
     filtros; o conjunto completo da marca é filtrado pelo índice (contagem e paginação sobre toda a seleção). */
  var Categoria = {
    NOMES: { 'freios': 'Freios', 'motor': 'Motor', 'suspensao': 'Suspensão', 'carroceria': 'Carroceria e carenagens', 'eletrica': 'Elétrica',
      'iluminacao': 'Iluminação', 'acessorios': 'Acessórios', 'arrefecimento': 'Arrefecimento', 'filtros': 'Filtros', 'oleos-e-fluidos': 'Óleos e fluidos', 'lifestyle': 'Lifestyle' },
    presente: function () { return !!$('[data-es-cat-filtro]'); },
    sincronizar: function () {
      var c = lerParam('es_cat') || '';
      if (!Categoria.NOMES[c]) c = '';
      $$('[data-es-cat-filtro] input[name="es_cat"]').forEach(function (r) { r.checked = r.value === c; });
      $$('[data-es-cat-atual]').forEach(function (el) { el.textContent = c ? Categoria.NOMES[c] : ''; });
      $$('[data-es-cat-limpar]').forEach(function (b) { b.hidden = !c; });
    },
    /* contagem por categoria no conjunto completo (demais filtros da URL e, se ligado, o veículo); categoria sem produto some */
    contar: function (itens, v) {
      var n = {}, total = 0;
      itens.forEach(function (it) {
        if (v) { if (it[6] === 'dispensa') return; if (avaliar(it[3], v, it[2], it[5] === true).s !== 'sim') return; }
        total++;
        var vistos = {};
        (it[8] || []).forEach(function (c) { if (!vistos[c]) { vistos[c] = 1; n[c] = (n[c] || 0) + 1; } });
      });
      var atual = lerParam('es_cat') || '';
      $$('[data-es-cat-filtro] [data-es-cat-opcao]').forEach(function (li) {
        var c = li.getAttribute('data-es-cat-opcao'), q = c ? (n[c] || 0) : total;
        var cont = $('[data-es-cat-n]', li); if (cont) cont.textContent = '(' + q + ')';
        li.hidden = !!c && !q && c !== atual;
      });
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-es-cat-limpar]');
    if (!b) return;
    e.preventDefault();
    definirParam('es_cat', null, true); definirParam('es_p', null);
    Categoria.sincronizar(); Filtro.agendar();
  });
  /* filtros e ordenação do Dawn refazem a URL a partir dos formulários: o campo oculto mantém o modo de filtro */
  function marcarFormularios() {
    var ligado = Filtro.veiculoAtivo();
    $$('facet-filters-form form').forEach(function (f) {
      var campo = $('input[name="es_veiculo"]', f);
      if (ligado && !campo) { campo = document.createElement('input'); campo.type = 'hidden'; campo.name = 'es_veiculo'; campo.value = '1'; f.appendChild(campo); }
      if (!ligado && campo) campo.remove();
    });
  }
  window.addEventListener('popstate', function () { if (Filtro.pagina()) { atualizarCards(); Filtro.agendar(); } });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.es-paginacao a[data-es-pagina]');
    if (a) {
      e.preventDefault();
      var n = parseInt(a.getAttribute('data-es-pagina'), 10);
      definirParam('es_p', n > 1 ? String(n) : null, true);
      Filtro.agendar();
      var alvo = document.getElementById('ProductGridContainer');
      if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    var tentar = e.target.closest && e.target.closest('[data-es-filtro-tentar]');
    if (tentar) { e.preventDefault(); Filtro.indices = {}; Filtro.agendar(); }
  });

  /* ---------- compatibilidade na página do produto ---------- */
  function atualizarPdp() {
    var v = Veiculo.ler();
    $$('[data-es-compat]').forEach(function (box) {
      var aplic = lerAplic(box);
      var r = avaliar(aplic, v, box.getAttribute('data-es-fornecedor'), box.hasAttribute('data-es-universal'));
      box.classList.toggle('es-compat--ok', r.s === 'sim');
      box.classList.toggle('es-compat--nao', r.s === 'nao');
      box.classList.toggle('es-compat--confirmar', r.s === 'confirmar');
      $$('[data-es-estado]', box).forEach(function (s) {
        var est = s.getAttribute('data-es-estado');
        s.hidden = !((est === 'ok' && r.s === 'sim') || (est === 'nao' && r.s === 'nao') || (est === 'confirmar' && r.s === 'confirmar') ||
          (est === 'sem-veiculo' && !v && aplic.length > 0) || (est === 'sem-dado' && !aplic.length && !box.hasAttribute('data-es-universal')));
      });
      $$('[data-es-falta]', box).forEach(function (t) {
        t.textContent = textoFalta(r);
      });
      $$('[data-es-nome-veiculo]', box).forEach(function (t) { t.textContent = Veiculo.nome(v); });
      $$('tr[data-es-linha]', box).forEach(function (tr) {
        var a = null; try { a = JSON.parse(tr.getAttribute('data-es-linha')); } catch (e) {}
        tr.classList.toggle('es-serve', avaliar([a], v, box.getAttribute('data-es-fornecedor')).s === 'sim');
      });
    });
    /* 03/11: tabela completa na área inferior (aba Compatibilidade) */
    $$('[data-es-compat-tabela]').forEach(function (t) {
      $$('tr[data-es-linha]', t).forEach(function (tr) {
        var a = null; try { a = JSON.parse(tr.getAttribute('data-es-linha')); } catch (e) {}
        tr.classList.toggle('es-serve', !!a && avaliar([a], v, t.getAttribute('data-es-fornecedor')).s === 'sim');
      });
    });
    atualizarZap();
  }

  /* ---------- links de atendimento (WhatsApp) acompanham a variante e o veículo ----------
     Mensagem: produto, opções escolhidas, código da variante atual (nunca o de outra variante), link com a variante
     e, só em peça com aplicação veicular, o veículo escolhido. Nada de sessão ou dado pessoal na URL. */
  function dadosProduto(raiz) {
    var el = $('script[data-es-produto]', raiz) || $('script[data-es-produto]');
    if (!el) return null;
    if (el._esDados) return el._esDados;
    try { el._esDados = JSON.parse(el.textContent); } catch (e) { el._esDados = null; }
    return el._esDados;
  }
  function varianteAtual(prod, raiz, preferida) {
    if (!prod || !Array.isArray(prod.variantes)) return null;
    var id = preferida && preferida.id;
    if (!id) {
      var campo = $('form[action*="/cart/add"] input[name="id"]', raiz) || $('form[action*="/cart/add"] input[name="id"]');
      id = campo && campo.value;
    }
    if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); id = m && m[1]; }
    id = String(id || '');
    for (var i = 0; i < prod.variantes.length; i++) if (String(prod.variantes[i].id) === id) return prod.variantes[i];
    return null;
  }
  function mensagemZap(prefixo, prod, variante, v) {
    var linhas = [String(prefixo || '').trim() + ' ' + prod.titulo];
    var codigo = '';
    if (prod.unica) codigo = (variante && variante.sku) || prod.codigo || '';
    else if (variante) {
      var ops = [];
      (prod.opcoes || []).forEach(function (nome, i) { if (variante.opcoes && variante.opcoes[i]) ops.push(nome + ': ' + variante.opcoes[i]); });
      if (ops.length) linhas.push(ops.join(', '));
      codigo = variante.sku || '';
    }
    if (codigo) linhas.push('Cód.: ' + codigo);
    if (prod.aplic && prod.classe !== 'dispensa' && v) linhas.push('Meu veículo: ' + Veiculo.nome(v) + (v.versao ? ' ' + v.versao : ''));
    linhas.push(location.origin + prod.url + (!prod.unica && variante ? '?variant=' + variante.id : ''));
    return linhas.join('\n');
  }
  var ultimaVariante = null;
  function atualizarZap(preferida) {
    if (preferida) ultimaVariante = preferida;
    $$('a[data-es-zap]').forEach(function (a) {
      var raiz = a.closest('section') || document;
      var prod = dadosProduto(raiz);
      if (!prod) return;
      var variante = varianteAtual(prod, raiz, ultimaVariante);
      var numero = a.getAttribute('data-es-zap');
      a.href = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensagemZap(a.getAttribute('data-es-zap-msg'), prod, variante, Veiculo.ler()));
    });
  }


  /* ---------- frete e prazo na PÁGINA DO PRODUTO (03/11/2026; substitui o frete do carrinho de 01–02/11) ----------
     Cotação REAL da loja para o produto, a variante e a quantidade escolhidos, SEM tocar no carrinho do comprador:
     um carrinho próprio de consulta é criado pela Storefront API da loja (acesso sem token, mesma origem, doc oficial
     shopify.dev/docs/api/storefront/latest/mutations/cartCreate) só com a linha escolhida e o CEP/UF. As opções vêm
     da transportadora configurada na loja (CarrierService, deliveryGroups withCarrierRates com @defer), as mesmas do
     checkout. Kit (pacote) = a Shopify expande os componentes, como no checkout. O carrinho do comprador nunca é lido
     nem alterado por esta consulta.
     Regras reaproveitadas do frete do carrinho (docs 51b, 53 e 54): estados distintos (andamento, tarifas, sem tarifa,
     CEP inválido, falha, tempo, desatualizado); prazo efetivo de LIMITE ms com AbortController e vigia de obsolescência
     (a fila sempre libera); fila única; resposta antiga descartada (CEP, variante ou quantidade mudaram); CEP digitado e
     não calculado guardado por formulário em sessionStorage (sobrevive à troca do HTML e à recarga); só o Calcular
     confirma o destino (estocar_cep). UF = faixa de CEP dos Correios (CEP fora das faixas = inválido; nunca se pede UF).
     Falha nunca vira frete grátis nem prazo fictício. */
  var CHAVE_CEP = 'estocar_cep', CHAVE_EDICAO = 'estocar_cep_edicao', API_SF = 'api/2025-10/graphql.json';
  var CONSULTA_SF = 'mutation EstocarFretePdp($v: ID!, $q: Int!, $z: String!, $u: String!) { cartCreate(input: { lines: [{ merchandiseId: $v, quantity: $q }], buyerIdentity: { countryCode: BR }, delivery: { addresses: [{ selected: true, oneTimeUse: true, address: { deliveryAddress: { zip: $z, provinceCode: $u, countryCode: BR } } }] } }) { cart { id ... @defer { deliveryGroups(first: 5, withCarrierRates: true) { nodes { deliveryOptions { title code description estimatedCost { amount currencyCode } } } } } } userErrors { field message code } warnings { code message } } }';
  var Frete = {
    LIMITE: 25000, VIGIA: 200, ESPERA: 2500, fila: Promise.resolve(),
    limpar: function (cep) { return String(cep || '').replace(/\D/g, '').slice(0, 8); },
    formatar: function (c) { return c.length > 5 ? c.slice(0, 5) + '-' + c.slice(5) : c; },
    FAIXAS: [[1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
      [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
      [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
      [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
      [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']],
    ufDoCep: function (c) { var n = parseInt(String(c).slice(0, 5), 10); for (var i = 0; i < Frete.FAIXAS.length; i++) if (n >= Frete.FAIXAS[i][0] && n <= Frete.FAIXAS[i][1]) return Frete.FAIXAS[i][2]; return ''; },
    dinheiro: function (v) { var n = parseFloat(v); return isNaN(n) ? '' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); },
    estado: function (f) { return f._esFrete || (f._esFrete = { seq: 0 }); },
    /* edição em curso (digitada e não calculada), por formulário; sobrevive à troca do HTML e à recarga */
    chave: function (f) { var c = $('input[name="cep"]', f); return (c && c.id) || 'pdp'; },
    _edicoes: {},
    edicoes: function () {
      try { var o = JSON.parse(sessionStorage.getItem(CHAVE_EDICAO) || '{}'); if (o && typeof o === 'object') return o; } catch (x) {}
      return Frete._edicoes;
    },
    gravarEdicoes: function (o) { Frete._edicoes = o; try { sessionStorage.setItem(CHAVE_EDICAO, JSON.stringify(o)); } catch (x) {} },
    edicao: function (f) { var d = Frete.edicoes()[Frete.chave(f)]; return d && typeof d.cep === 'string' ? d : null; },
    sujo: function (f) { return !!Frete.edicao(f); },
    guardarEdicao: function (f) {
      var campo = $('input[name="cep"]', f), o = Frete.edicoes();
      o[Frete.chave(f)] = { cep: campo ? campo.value : '' };
      Frete.gravarEdicoes(o);
    },
    descartarEdicao: function (f) { var o = Frete.edicoes(), k = Frete.chave(f); if (k in o) { delete o[k]; Frete.gravarEdicoes(o); } },
    /* formulário novo ou página recarregada: devolve a edição em curso, sem cotar e sem confirmar nada */
    restaurarEdicao: function (f) {
      var d = Frete.edicao(f), campo = $('input[name="cep"]', f);
      if (!d || !campo) return false;
      Frete.estado(f).seq++;
      campo.value = d.cep;
      if (d.cep) Frete.escrever(f, 'CEP alterado e ainda não calculado: clique em Calcular para ver o frete e o prazo.', 'desatualizado');
      return true;
    },
    /* último destino confirmado pelo comprador: {cep, uf}. Aceita o formato antigo (só os 8 números). */
    destino: function () {
      var s = ''; try { s = sessionStorage.getItem(CHAVE_CEP) || ''; } catch (e) { return null; }
      if (/^\d{8}$/.test(s)) return { cep: s, uf: Frete.ufDoCep(s) };
      try { var d = JSON.parse(s); return d && /^\d{8}$/.test(d.cep) ? { cep: d.cep, uf: Frete.ufDoCep(d.cep) } : null; } catch (e) { return null; }
    },
    escolher: function (cep, uf) { try { sessionStorage.setItem(CHAVE_CEP, JSON.stringify({ cep: cep, uf: uf })); } catch (x) {} },
    /* põe no campo o destino confirmado (sem cotar), se o comprador não estiver editando este formulário */
    sincronizar: function (f) {
      var d = Frete.destino(), campo = $('input[name="cep"]', f);
      if (!d || !campo || Frete.sujo(f) || campo.value) return false;
      campo.value = Frete.formatar(d.cep);
      return true;
    },
    escrever: function (f, conteudo, tipo) {
      var r = $('[data-es-frete-resultado]', f); if (!r) return;
      r.setAttribute('data-es-frete-estado', tipo || '');
      r.classList.toggle('es-frete__resultado--erro', /^(erro|cep|falha|tempo|sem-tarifa|indisponivel)$/.test(tipo || ''));
      r.setAttribute('aria-busy', tipo === 'andamento' ? 'true' : 'false');
      r.textContent = '';
      if (typeof conteudo === 'string') r.textContent = conteudo; else if (conteudo) r.appendChild(conteudo);
    },
    /* invalida a cotação exibida (CEP, variante ou quantidade mudaram); a consulta em curso vira obsoleta */
    invalidar: function (f, motivo) {
      var e = Frete.estado(f); e.seq++;
      var r = $('[data-es-frete-resultado]', f);
      if (r && r.textContent) Frete.escrever(f, motivo, 'desatualizado');
      var b = $('button[type="submit"]', f); if (b) b.disabled = false;
    },
    /* variante e quantidade escolhidas no formulário de compra desta página (nunca as do carrinho) */
    linha: function (f) {
      var s = f.getAttribute('data-es-secao') || '';
      var id = document.querySelector('#product-form-' + s + ' input[name="id"]') || document.querySelector('product-info form[action*="/cart/add"] input[name="id"]');
      var q = document.getElementById('Quantity-' + s);
      var qtd = q ? parseInt(q.value, 10) : 1;
      return { id: id && !id.disabled && /^\d+$/.test(id.value || '') ? id.value : '', qtd: isNaN(qtd) || qtd < 1 ? 1 : qtd };
    },
    enfileirar: function (tarefa) { var p = Frete.fila.then(tarefa, tarefa); Frete.fila = p.then(function () {}, function () {}); return p; },
    /* resposta da Storefront com @defer: multipart/mixed (partes JSON) ou JSON único; junta erros e opções */
    lerResposta: function (t) {
      var partes = [];
      String(t || '').split(/\r?\n/).forEach(function (l) { l = l.trim(); if (l.charAt(0) === '{') { try { partes.push(JSON.parse(l)); } catch (e) {} } });
      if (!partes.length) { try { partes.push(JSON.parse(t)); } catch (e) { throw { tipo: 'falha', http: 'json' }; } }
      var out = { erros: [], grupos: null, final: false };
      partes.forEach(function (p) {
        if (p.errors && p.errors.length) out.erros = out.erros.concat(p.errors.map(function (x) { return { code: 'GRAPHQL', message: x.message }; }));
        var cc = p.data && p.data.cartCreate;
        if (cc) { out.erros = out.erros.concat(cc.userErrors || []).concat((cc.warnings || []).filter(function (w) { return /STOCK|AVAILABLE|MERCHANDISE/.test(w.code || ''); })); if (cc.cart && cc.cart.deliveryGroups) out.grupos = cc.cart.deliveryGroups.nodes; }
        (p.incremental || []).forEach(function (inc) {
          if (inc.data && inc.data.deliveryGroups) out.grupos = inc.data.deliveryGroups.nodes;
          /* erro no fragmento adiado (ex.: THROTTLED "temporarily unavailable"): é falha, nunca "sem transportadora" */
          (inc.errors || []).forEach(function (x) { out.erros.push({ code: (x.extensions && x.extensions.code) || 'GRAPHQL', message: x.message }); });
        });
        if (p.hasNext === false || (!('hasNext' in p) && cc)) out.final = true;
      });
      return out;
    },
    consultar: function (variaveis, valido) {
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      var fim = false, relogio = null, vigia = null;
      function encerrar() { fim = true; clearTimeout(relogio); clearInterval(vigia); if (ctl) { try { ctl.abort(); } catch (e) {} } }
      /* prazo total (requisição + leitura do corpo) e vigia de obsolescência: rejeitam mesmo que a rede nunca responda */
      var prazo = new Promise(function (ok, falha) {
        relogio = setTimeout(function () { falha({ tipo: 'tempo' }); }, Frete.LIMITE);
        vigia = setInterval(function () { if (!valido()) falha({ tipo: 'obsoleto' }); }, Frete.VIGIA);
      });
      var o = { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'multipart/mixed; deferSpec=20220824, application/json' },
        body: JSON.stringify({ query: CONSULTA_SF, variables: variaveis }) };
      if (ctl) o.signal = ctl.signal;
      var op = fetch(raizLoja + API_SF, o).then(function (r) {
        if (fim) throw { tipo: 'obsoleto' };
        if (!r.ok) throw { tipo: 'falha', http: r.status };
        return r.text();
      }).then(function (t) {
        if (fim) throw { tipo: 'obsoleto' };
        return Frete.lerResposta(t);
      });
      op.catch(function () {});   /* depois do prazo/cancelamento, a rejeição tardia não vira erro solto */
      return Promise.race([op, prazo]).then(function (v) { encerrar(); return v; }, function (x) {
        encerrar();
        if (x && x.tipo) throw x;
        throw { tipo: 'falha', http: 'rede' };
      });
    },
    calcular: function (form) {
      var e = Frete.estado(form), campo = $('input[name="cep"]', form);
      var cep = Frete.limpar(campo && campo.value);
      e.seq++;
      var token = e.seq;
      if (cep.length !== 8) { Frete.escrever(form, 'Digite um CEP com 8 números.', 'cep'); if (campo) campo.focus(); return Promise.resolve(); }
      if (campo) campo.value = Frete.formatar(cep);
      var uf = Frete.ufDoCep(cep);
      if (!uf) { Frete.escrever(form, 'CEP ' + Frete.formatar(cep) + ' inválido: confira os números.', 'cep'); if (campo) campo.focus(); return Promise.resolve(); }
      var l = Frete.linha(form);
      if (!l.id) { Frete.escrever(form, 'Esta opção do produto está indisponível: não é possível calcular o frete. Escolha outra opção ou fale com a Estocar pelo WhatsApp.', 'indisponivel'); return Promise.resolve(); }
      /* só o Calcular confirma o destino e encerra a edição deste formulário */
      Frete.descartarEdicao(form); Frete.escolher(cep, uf);
      var botao = $('button[type="submit"]', form);
      if (botao) botao.disabled = true;
      Frete.escrever(form, 'Calculando o frete e o prazo para ' + Frete.formatar(cep) + '…', 'andamento');
      var valido = function () {
        var a = Frete.linha(form);
        return form.isConnected && e.seq === token && Frete.limpar(campo && campo.value) === cep && a.id === l.id && a.qtd === l.qtd;
      };
      var vars = { v: 'gid://shopify/ProductVariant/' + l.id, q: l.qtd, z: Frete.formatar(cep), u: uf }, inicio = Date.now();
      /* cotação limitada temporariamente pela Shopify (THROTTLED): uma nova tentativa após ESPERA ms, dentro do prazo LIMITE */
      function cotar(tentativa) {
        return Frete.consultar(vars, valido).then(function (r) {
          var limitado = r.erros.some(function (x) { return /THROTTLED/.test(x.code || ''); });
          if (limitado && !tentativa && valido() && Date.now() - inicio + Frete.ESPERA < Frete.LIMITE - 5000) {
            return new Promise(function (ok) { setTimeout(ok, Frete.ESPERA); }).then(function () { if (!valido()) throw { tipo: 'obsoleto' }; return cotar(1); });
          }
          return r;
        });
      }
      return Frete.enfileirar(function () {
        if (!valido()) return null;
        return cotar(0).then(function (r) {
          if (!valido()) return;
          if (r.erros.length) {
            var cod = r.erros.map(function (x) { return x.code || ''; }).join(' ');
            if (/STOCK|NOT_ENOUGH|AVAILABLE|INVALID_MERCHANDISE|MERCHANDISE/.test(cod)) Frete.escrever(form, 'Quantidade ou opção indisponível no estoque para ' + l.qtd + (l.qtd > 1 ? ' unidades' : ' unidade') + '. Ajuste a quantidade ou fale com a Estocar pelo WhatsApp.', 'indisponivel');
            else if (/THROTTLED/.test(cod)) Frete.escrever(form, 'A consulta de frete está temporariamente indisponível. Tente de novo em instantes; o frete também aparece no checkout.', 'falha');
            else if (/ZIP|ADDRESS|PROVINCE|DELIVERY/.test(cod)) Frete.escrever(form, 'CEP ' + Frete.formatar(cep) + ' não aceito para entrega. Confira os números.', 'cep');
            else Frete.escrever(form, 'Não foi possível consultar o frete agora (falha de comunicação). Tente de novo em instantes.', 'falha');
            return;
          }
          if (!r.final || r.grupos === null) { Frete.escrever(form, 'Não foi possível consultar o frete agora (resposta incompleta). Tente de novo em instantes.', 'falha'); return; }
          var opcoes = [];
          (r.grupos || []).forEach(function (g) { (g.deliveryOptions || []).forEach(function (op) { if (op && op.estimatedCost && op.estimatedCost.amount != null) opcoes.push(op); }); });
          if (!opcoes.length) { Frete.escrever(form, 'Nenhuma transportadora retornou entrega para o CEP ' + Frete.formatar(cep) + ' com este produto e quantidade. Confira o CEP; se estiver correto, fale com a Estocar pelo WhatsApp.', 'sem-tarifa'); return; }
          var cx = document.createElement('div'), ul = document.createElement('ul'); ul.className = 'es-frete__lista';
          opcoes.forEach(function (t) {
            var li = document.createElement('li');
            var nome = document.createElement('span'); nome.textContent = t.title || 'Transportadora';
            var preco = document.createElement('b'); preco.textContent = Frete.dinheiro(t.estimatedCost.amount);
            li.appendChild(nome); li.appendChild(preco);
            if (t.description) { var prazo = document.createElement('small'); prazo.textContent = t.description; li.appendChild(prazo); }
            ul.appendChild(li);
          });
          cx.appendChild(ul);
          var obs = document.createElement('small');
          obs.textContent = 'Para o CEP ' + Frete.formatar(cep) + ' (' + uf + '), ' + l.qtd + (l.qtd > 1 ? ' unidades' : ' unidade') + ' desta opção. Valor e prazo da transportadora; confirmação no checkout.';
          cx.appendChild(obs);
          Frete.escrever(form, cx, 'tarifas');
        }).catch(function (x) {
          if (!x || x.tipo === 'obsoleto' || !valido()) return;
          if (x.tipo === 'tempo') Frete.escrever(form, 'A consulta do frete demorou mais que o esperado. Tente de novo em instantes; o frete também aparece no checkout.', 'tempo');
          else Frete.escrever(form, 'Não foi possível consultar o frete agora (falha de comunicação). Tente de novo; o frete também aparece no checkout.', 'falha');
        });
      }).then(function () { if (botao && e.seq === token) botao.disabled = false; });
    },
    preparar: function (raiz) {
      $$('[data-es-frete]', raiz || document).forEach(function (f) {
        var campo = $('input[name="cep"]', f);
        if (!campo || f.dataset.esPronto) return;
        f.dataset.esPronto = '1';
        if (!Frete.restaurarEdicao(f)) Frete.sincronizar(f);
        campo.addEventListener('input', function () {
          var c = Frete.limpar(campo.value), fmt = Frete.formatar(c);
          if (campo.value !== fmt) campo.value = fmt;
          Frete.guardarEdicao(f);
          Frete.invalidar(f, 'CEP alterado: clique em Calcular para ver o frete do novo CEP.');
        });
      });
    },
    /* variante ou quantidade mudou na página: a cotação exibida (ou em curso) deixa de valer */
    linhaMudou: function () {
      $$('[data-es-frete]').forEach(function (f) { Frete.invalidar(f, 'Opção ou quantidade alterada: clique em Calcular para atualizar o frete e o prazo.'); });
    }
  };
  window.EstocarFrete = Frete;
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-es-frete]');
    if (!f) return;
    e.preventDefault(); Frete.preparar(f.parentNode); Frete.calcular(f);
  });
  document.addEventListener('focusin', function (e) { var f = e.target && e.target.closest && e.target.closest('[data-es-frete]'); if (f) Frete.preparar(f.parentNode); });
  /* quantidade da página do produto (digitada ou pelos botões + / −, que disparam change) */
  ['change', 'input'].forEach(function (tipo) {
    document.addEventListener(tipo, function (e) {
      var q = e.target;
      if (q && q.name === 'quantity' && q.id && q.id.indexOf('Quantity-') === 0 && !q.closest('cart-items, cart-drawer-items')) Frete.linhaMudou();
    });
  });
  if (typeof MutationObserver === 'function') new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && ((n.matches && n.matches('[data-es-frete]')) || n.querySelector('[data-es-frete]:not([data-es-pronto])'))) { Frete.preparar(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* recomendações do carrinho acompanham a lista de itens (página e gaveta); o carrinho não consulta frete */
  var obsItens = null, tItens = null;
  function observarItens() {
    if (obsItens) obsItens.disconnect();
    obsItens = new MutationObserver(function () {
      clearTimeout(tItens);
      tItens = setTimeout(function () { Recomenda.executar(); }, 700);
    });
    $$('cart-items, cart-drawer-items').forEach(function (el) { obsItens.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); });
  }
  function ligarCarrinho() {
    observarItens();
    /* PUB_SUB_EVENTS do Dawn é "const" global (não fica em window): lê pelo nome */
    var ev = null; try { ev = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null; } catch (e) {}
    if (typeof window.subscribe === 'function' && ev && !ligarCarrinho.ok) {
      ligarCarrinho.ok = true;
      window.subscribe(ev, function () { setTimeout(function () { Recomenda.executar(); observarItens(); }, 300); });
    }
  }

  /* ---------- recomendações do carrinho (Fase 3) ----------
     Com veículo e peça veicular no carrinho: só peças CONFIRMADAS para o veículo (avaliar = 'sim'), disponíveis, com
     foto real (8º campo do índice) e fora do carrinho. Com roupa/acessório: itens das mesmas coleções de roupas.
     Sem nada relevante: seção oculta. */
  var Recomenda = {
    executar: function () {
      var sec = $('[data-es-rec-carrinho]');
      if (!sec) return;
      var lista = $('[data-es-rec-lista]', sec), titulo = $('[data-es-rec-titulo]', sec), sub = $('[data-es-rec-sub]', sec);
      fetch(raizLoja + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var noCarrinho = {}; (cart.items || []).forEach(function (i) { noCarrinho[i.handle] = 1; });
        if (!cart.items || !cart.items.length) { sec.hidden = true; return null; }
        var v = Veiculo.ler(), veicular = sec.getAttribute('data-es-veicular') === 'true';
        var colsRoupa = (sec.getAttribute('data-es-cols-roupa') || '').split(',').filter(Boolean);
        var pedidos = [];
        if (v && veicular) pedidos.push(Filtro.indice({ caminho: raizLoja + 'collections/all', busca: '' }).then(function (itens) {
          return { tipo: 'veiculo', itens: itens.filter(function (it) { return it[4] === true && it[7] === true && it[6] !== 'dispensa' && !noCarrinho[it[1]] && avaliar(it[3], v, it[2], it[5] === true).s === 'sim'; }) };
        }));
        if (colsRoupa.length) colsRoupa.forEach(function (c) {
          pedidos.push(Filtro.indice({ caminho: raizLoja + 'collections/' + c, busca: '' }).then(function (itens) {
            return { tipo: 'roupa', itens: itens.filter(function (it) { return it[4] === true && it[7] === true && !noCarrinho[it[1]]; }) };
          }));
        });
        if (!pedidos.length) { sec.hidden = true; return null; }
        return Promise.all(pedidos).then(function (rs) {
          var vistos = {}, esc = [], tipo = '';
          rs.forEach(function (r) { r.itens.forEach(function (it) { if (!vistos[it[1]] && esc.length < 4) { vistos[it[1]] = 1; esc.push(it); tipo = tipo || r.tipo; } }); });
          if (!esc.length) { sec.hidden = true; return; }
          return Filtro.carregarCards(esc).then(function (htmls) {
            lista.innerHTML = htmls.map(function (h) { return '<li class="grid__item">' + h + '</li>'; }).join('');
            titulo.textContent = tipo === 'veiculo' ? 'Também servem no seu ' + Veiculo.nome(v) : 'Mais roupas e equipamentos';
            sub.textContent = tipo === 'veiculo' ? 'Peças com aplicação confirmada para o veículo escolhido.' : '';
            sec.hidden = false; atualizarCards();
          });
        });
      }).catch(function () { sec.hidden = true; });
    }
  };

  /* ---------- recomendações da página do produto (03/11/2026) ----------
     "Quem compra esta peça também leva": só peças da MESMA marca (fornecedor), publicadas (índice da loja), disponíveis,
     com foto real, fora a própria. Com veículo escolhido: a peça principal e a recomendada têm de estar CONFIRMADAS
     (avaliar = 'sim') para esse veículo (modelo, ano, versão, geração e restrições pela regra única avaliar). Sem
     veículo: só com aplicação CONFIRMADA EM COMUM com a peça principal (mesma marca da aplicação, mesmo modelo, versão
     compatível, mesma geração — geração informada de um lado só = ambígua, não vale — e período de fabricação que se
     cruza). "A confirmar" nunca entra. Sem indicação segura: a seção fica oculta.
     "Você pode gostar": produtos das coleções Lifestyle (classificação real: bmw-lifestyle e motorrad-lifestyle-rider),
     disponíveis e com foto real, primeiro os da marca do produto principal; nunca peça mecânica. Vazio = oculta. */
  function periodoMeses(a) {
    var d = mesNum(a.de_mes), t = mesNum(a.ate_mes);
    if (d != null && t != null) return [d, t];
    var de = parseInt(a.de, 10), ate = parseInt(a.ate || a.de, 10);
    if (!isNaN(de) && !isNaN(ate)) return [de * 12, ate * 12 + 11];
    return null;
  }
  function aplicacaoEmComum(a, b, fa, fb) {
    if (a.confirmar || b.confirmar) return false;
    if (norm(a.marca || fa) !== norm(b.marca || fb) || norm(a.modelo) !== norm(b.modelo)) return false;
    var ga = norm(a.geracao || ''), gb = norm(b.geracao || '');
    if (ga !== gb) return false;
    if (a.versao && b.versao && !versaoConfere(a.versao, b.versao) && !versaoConfere(b.versao, a.versao)) return false;
    var pa = periodoMeses(a), pb = periodoMeses(b);
    return !!(pa && pb && pa[0] <= pb[1] && pb[0] <= pa[1]);
  }
  function emComum(la, lb, fa, fb) {
    var n = 0;
    la.forEach(function (a) { if (lb.some(function (b) { return aplicacaoEmComum(a, b, fa, fb); })) n++; });
    return n;
  }
  var RecPdp = {
    seq: 0,
    executar: function () {
      var secs = $$('[data-es-rec-pdp]');
      if (!secs.length) return;
      var token = ++RecPdp.seq;
      secs.forEach(function (sec) {
        var tipo = sec.getAttribute('data-es-rec-pdp'), lista = $('[data-es-rec-lista]', sec);
        var proprio = sec.getAttribute('data-es-handle'), forn = sec.getAttribute('data-es-fornecedor') || '';
        var limite = parseInt(sec.getAttribute('data-es-limite') || '4', 10);
        var pedido;
        if (tipo === 'pecas') {
          if (sec.getAttribute('data-es-classe') === 'dispensa') { sec.hidden = true; return; }
          var minhas = listaAplic(lerAplic(sec)), v = Veiculo.ler();
          var euSirvo = v ? avaliar(minhas, v, forn, sec.hasAttribute('data-es-universal')).s === 'sim' : false;
          if (v && !euSirvo) { sec.hidden = true; return; }
          if (!v && !minhas.length) { sec.hidden = true; return; }
          pedido = Filtro.indice({ caminho: raizLoja + 'collections/all', busca: '' }).then(function (itens) {
            var esc = [];
            itens.forEach(function (it, i) {
              if (it[1] === proprio || it[4] !== true || it[7] !== true || it[6] === 'dispensa' || norm(it[2]) !== norm(forn)) return;
              if (v) { if (avaliar(it[3], v, it[2], it[5] === true).s === 'sim') esc.push({ it: it, n: 1, i: i }); return; }
              var n = emComum(minhas, listaAplic(it[3]), forn, it[2]);
              if (n) esc.push({ it: it, n: n, i: i });
            });
            esc.sort(function (a, b) { return b.n - a.n || a.i - b.i; });
            sec.setAttribute('data-es-rec-modo', v ? 'veiculo' : 'comum');
            var sub = $('[data-es-rec-sub]', sec);
            if (sub) sub.textContent = v ? 'Peças ' + forn + ' com aplicação confirmada para o seu ' + Veiculo.nome(v) + '.' : 'Peças ' + forn + ' com aplicação confirmada em comum com esta peça.';
            return esc.slice(0, limite).map(function (x) { return x.it; });
          });
        } else {
          var cols = (sec.getAttribute('data-es-colecoes') || '').split(',').filter(Boolean);
          pedido = Promise.all(cols.map(function (c) { return Filtro.indice({ caminho: raizLoja + 'collections/' + c, busca: '' }).catch(function () { return []; }); })).then(function (rs) {
            var vistos = {}, todos = [];
            rs.forEach(function (itens) { itens.forEach(function (it, i) { if (!vistos[it[1]] && it[1] !== proprio && it[4] === true && it[7] === true) { vistos[it[1]] = 1; todos.push({ it: it, i: todos.length }); } }); });
            todos.sort(function (a, b) { return (norm(b.it[2]) === norm(forn)) - (norm(a.it[2]) === norm(forn)) || a.i - b.i; });
            return todos.slice(0, limite).map(function (x) { return x.it; });
          });
        }
        pedido.then(function (esc) {
          if (token !== RecPdp.seq) return;
          if (!esc.length) { sec.hidden = true; return; }
          return Filtro.carregarCards(esc).then(function (htmls) {
            if (token !== RecPdp.seq) return;
            lista.innerHTML = htmls.map(function (h) { return '<li class="grid__item">' + h + '</li>'; }).join('');
            sec.hidden = false; atualizarCards();
          });
        }).catch(function () { if (token === RecPdp.seq) sec.hidden = true; });
      });
    }
  };

  /* ---------- carrossel de banners ---------- */
  function vigente(el, agora) {
    var i = el.getAttribute('data-inicio'), f = el.getAttribute('data-fim');
    var ti = i ? Date.parse(i) : NaN, tf = f ? Date.parse(f.length === 10 ? f + 'T23:59:59' : f) : NaN;
    if (!isNaN(ti) && agora < ti) return false;
    if (!isNaN(tf) && agora > tf) return false;
    return true;
  }
  function iniciarValidade() {
    var agora = Date.now();
    $$('[data-es-validade]').forEach(function (el) { if (!vigente(el, agora) && !window.Shopify?.designMode) el.hidden = true; });
  }
  function iniciarCarrossel(raiz) {
    var trilho = $('.es-carrossel__trilho', raiz);
    var slides = $$('.es-slide', raiz).filter(function (s) { return !s.hidden; });
    var pontos = $('.es-pontos', raiz);
    if (!trilho || !slides.length) { raiz.hidden = !window.Shopify?.designMode; return; }
    $$('.es-slide', raiz).forEach(function (s) { if (s.hidden) s.remove(); });
    var atual = 0, timer = null, pausado = false, reduzido = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var intervalo = parseInt(raiz.getAttribute('data-intervalo') || '6', 10) * 1000;
    if (pontos) {
      pontos.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Banner ' + (i + 1) + ' de ' + slides.length);
        b.addEventListener('click', function () { ir(i); }); pontos.appendChild(b);
      });
    }
    function ir(i) {
      atual = (i + slides.length) % slides.length;
      trilho.style.transform = 'translateX(-' + (atual * 100) + '%)';
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k !== atual); $$('a,button', s).forEach(function (x) { x.tabIndex = k === atual ? 0 : -1; }); });
      if (pontos) $$('button', pontos).forEach(function (b, k) { b.setAttribute('aria-current', k === atual); });
      reiniciar();
    }
    function reiniciar() { clearInterval(timer); if (!pausado && !reduzido && slides.length > 1) timer = setInterval(function () { ir(atual + 1); }, intervalo); }
    var bPausa = $('[data-es-pausa]', raiz), bAnt = $('[data-es-anterior]', raiz), bProx = $('[data-es-proximo]', raiz);
    if (slides.length < 2) { $$('.es-carrossel__ctrl', raiz).forEach(function (c) { c.hidden = true; }); }
    if (bAnt) bAnt.onclick = function () { ir(atual - 1); };
    if (bProx) bProx.onclick = function () { ir(atual + 1); };
    if (bPausa) bPausa.onclick = function () { pausado = !pausado; $$('[data-es-video]', raiz).forEach(function (m) { if (m._esPausar) m._esPausar(pausado); }); bPausa.setAttribute('aria-pressed', pausado); bPausa.setAttribute('aria-label', pausado ? 'Retomar banners' : 'Pausar banners'); bPausa.textContent = pausado ? '▶' : '❚❚'; reiniciar(); };
    raiz.addEventListener('mouseenter', function () { clearInterval(timer); });
    raiz.addEventListener('mouseleave', reiniciar);
    raiz.addEventListener('focusin', function () { clearInterval(timer); });
    raiz.addEventListener('focusout', reiniciar);
    var x0 = null;
    raiz.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    raiz.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) ir(atual + (dx < 0 ? 1 : -1)); x0 = null; });
    raiz._esIr = function (el) {
      var i = slides.indexOf(el);
      if (i > -1) { pausado = true; ir(i); clearInterval(timer); }
    };
    raiz._esRetomar = function () { pausado = false; reiniciar(); };
    ir(0);
  }
  /* editor do tema: mostra e pausa o banner selecionado */
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.es-slide');
    var raiz = slide && slide.closest('[data-es-carrossel]');
    if (raiz && raiz._esIr) raiz._esIr(slide);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var raiz = e.target.closest && e.target.closest('[data-es-carrossel]');
    if (raiz && raiz._esRetomar) raiz._esRetomar();
  });

  /* ---------- vídeo de banner: só carrega quando aparece; versão do dispositivo; pausa; sem vídeo com movimento
     reduzido ou economia de dados (fica a imagem de capa) ---------- */
  function iniciarVideos(raiz) {
    var semVideo = matchMedia('(prefers-reduced-motion: reduce)').matches || !!(navigator.connection && navigator.connection.saveData);
    $$('[data-es-video]', raiz).forEach(function (m) {
      if (m.dataset.esPronto) return;
      m.dataset.esPronto = '1';
      if (semVideo) return;
      var quando = matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador';
      var el = $('video[data-es-quando="' + quando + '"]', m) || $('video', m) || $('iframe[data-src]', m);
      if (!el) return;
      var botao = $('[data-es-video-pausa]', m);
      var carregado = false, pausadoUsuario = false, visivel = false;
      function carregar() {
        if (carregado) return;
        carregado = true;
        if (el.tagName === 'VIDEO') {
          $$('source[data-src]', el).forEach(function (s) { s.src = s.getAttribute('data-src'); });
          el.addEventListener('playing', function () { el.classList.add('es-tocando'); });
          el.load();
        } else {
          el.addEventListener('load', function () { if (el.src && el.src !== 'about:blank') el.classList.add('es-tocando'); });
        }
      }
      function tocar() {
        if (pausadoUsuario || !visivel) return;
        carregar();
        if (el.tagName === 'VIDEO') { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!el.src || el.src === 'about:blank') el.src = el.getAttribute('data-src');
        if (botao) botao.hidden = false;
      }
      function parar() {
        if (el.tagName === 'VIDEO') el.pause();
        else if (el.src && el.src !== 'about:blank') { el.classList.remove('es-tocando'); el.src = 'about:blank'; }
      }
      m._esPausar = function (p) { pausadoUsuario = p; if (p) parar(); else tocar(); atualizarBotao(); };
      function atualizarBotao() {
        if (!botao) return;
        botao.setAttribute('aria-pressed', pausadoUsuario);
        botao.setAttribute('aria-label', pausadoUsuario ? 'Reproduzir vídeo' : 'Pausar vídeo');
        botao.textContent = pausadoUsuario ? '▶' : '❚❚';
      }
      if (botao) botao.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); m._esPausar(!pausadoUsuario); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { visivel = en.isIntersecting; if (visivel) tocar(); else parar(); });
        }, { threshold: 0.25 }).observe(m);
      } else { visivel = true; tocar(); }
    });
  }

  /* ---------- contagem regressiva ---------- */
  function iniciarContagem(el) {
    var fim = Date.parse(el.getAttribute('data-fim'));
    if (isNaN(fim)) { el.hidden = true; return; }
    var bs = $$('b', el);
    function tick() {
      var s = Math.max(0, (fim - Date.now()) / 1000);
      var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), Math.floor(s % 60)];
      bs.forEach(function (b, i) { b.textContent = String(v[i]).padStart(2, '0'); });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- abas genéricas ---------- */
  function iniciarAbas(raiz) {
    var botoes = $$('[role="tab"]', raiz);
    botoes.forEach(function (b) {
      b.addEventListener('click', function () {
        botoes.forEach(function (x) {
          var sel = x === b; x.setAttribute('aria-selected', sel); x.tabIndex = sel ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !sel;
        });
      });
      b.addEventListener('keydown', function (e) {
        var i = botoes.indexOf(b);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = botoes[(i + (e.key === 'ArrowRight' ? 1 : -1) + botoes.length) % botoes.length]; n.focus(); n.click(); }
      });
    });
  }

  /* ---------- área de detalhes da página do produto (03/11/2026) ----------
     Computador (>= 750 px): abas acessíveis (setas, Home/End), Descrição aberta. Celular: seções expansíveis
     (botões com aria-expanded). O conteúdo existe uma vez só; muda apenas o papel (tabpanel/region). */
  var InfoPdp = {
    seq: 0,
    mq: window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true },
    iniciar: function (raiz) {
      $$('[data-es-pdp-info]', raiz).forEach(function (box) {
        if (box.dataset.esPronto) return;
        box.dataset.esPronto = '1';
        var abas = $$('[data-es-info-aba]', box), lista = $('[data-es-info-abas]', box), aberto = {};
        var atual = abas.length ? abas[0].getAttribute('data-es-info-aba') : null;
        $$('[data-es-info-sanfona]', box).forEach(function (b, i) { aberto[b.getAttribute('data-es-info-sanfona')] = i === 0; });
        function aplicar() {
          var desk = InfoPdp.mq.matches;
          if (lista) lista.hidden = !desk;
          box.classList.toggle('es-pdp-info--abas', desk);
          $$('[data-es-info-item]', box).forEach(function (it) {
            var k = it.getAttribute('data-es-info-item'), p = $('[data-es-info-painel]', it), h = $('.es-pdp-info__titulo', it), b = $('[data-es-info-sanfona]', it);
            if (desk) { h.hidden = true; p.setAttribute('role', 'tabpanel'); p.setAttribute('aria-labelledby', 'es-info-aba-' + k); p.tabIndex = 0; p.hidden = k !== atual; }
            else { h.hidden = false; p.setAttribute('role', 'region'); p.setAttribute('aria-labelledby', 'es-info-btn-' + k); p.removeAttribute('tabindex'); p.hidden = !aberto[k]; b.setAttribute('aria-expanded', aberto[k] ? 'true' : 'false'); }
          });
          abas.forEach(function (a) { var sel = a.getAttribute('data-es-info-aba') === atual; a.setAttribute('aria-selected', sel ? 'true' : 'false'); a.tabIndex = sel ? 0 : -1; });
        }
        abas.forEach(function (a, i) {
          a.addEventListener('click', function () { atual = a.getAttribute('data-es-info-aba'); aplicar(); });
          a.addEventListener('keydown', function (e) {
            var n = null;
            if (e.key === 'ArrowRight') n = abas[(i + 1) % abas.length];
            else if (e.key === 'ArrowLeft') n = abas[(i - 1 + abas.length) % abas.length];
            else if (e.key === 'Home') n = abas[0];
            else if (e.key === 'End') n = abas[abas.length - 1];
            if (n) { e.preventDefault(); n.focus(); n.click(); }
          });
        });
        $$('[data-es-info-sanfona]', box).forEach(function (b) {
          b.addEventListener('click', function () { var k = b.getAttribute('data-es-info-sanfona'); aberto[k] = !aberto[k]; aplicar(); });
        });
        box._esAbrir = function (k) {
          if (!$('[data-es-info-item="' + k + '"]', box)) return;
          atual = k; aberto[k] = true; aplicar();
          var alvo = InfoPdp.mq.matches ? $('[data-es-info-aba="' + k + '"]', box) : $('[data-es-info-sanfona="' + k + '"]', box);
          if (alvo) { alvo.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(function () { alvo.focus(); }, 350); }
        };
        if (InfoPdp.mq.addEventListener) InfoPdp.mq.addEventListener('change', aplicar); else if (InfoPdp.mq.addListener) InfoPdp.mq.addListener(aplicar);
        aplicar();
      });
    },
    /* troca de variante: código e peso da área inferior vêm da própria seção renderizada para a variante */
    variante: function (v) {
      var box = $('[data-es-pdp-info]');
      if (!box || !v || !v.id || v.id === 'nenhuma') return;
      var seq = ++InfoPdp.seq;
      fetch(location.pathname + '?variant=' + encodeURIComponent(v.id) + '&section_id=' + encodeURIComponent(box.getAttribute('data-es-secao')), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          if (!t || seq !== InfoPdp.seq) return;
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var novos = $$('[data-es-por-variante]', doc), atuais = $$('[data-es-por-variante]', box);
          if (novos.length === atuais.length) atuais.forEach(function (el, i) { el.replaceWith(document.importNode(novos[i], true)); });
        }).catch(function () {});
    }
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-es-info-abrir]');
    if (!a) return;
    var box = $('[data-es-pdp-info]');
    if (!box || !box._esAbrir) return;
    e.preventDefault(); box._esAbrir(a.getAttribute('data-es-info-abrir'));
  });

  /* ---------- copiar código ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-es-copiar]');
    if (b) {
      var t = b.getAttribute('data-es-copiar');
      var feito = function () { var o = b.textContent; b.textContent = 'Copiado'; setTimeout(function () { b.textContent = o; }, 1500); };
      if (navigator.clipboard) navigator.clipboard.writeText(t).then(feito, function () {}); else feito();
    }
    var rem = e.target.closest && e.target.closest('[data-es-remover-veiculo], [data-es-limpar-veiculo]');
    if (rem) { e.preventDefault(); removerVeiculo(rem); }
    var tro = e.target.closest && e.target.closest('[data-es-trocar-veiculo]');
    if (tro) { e.preventDefault(); trocarVeiculo(tro); }
  });

  /* ---------- código e especificações acompanham a variante escolhida ---------- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var d = ev && ev.data;
      if (!d) return;
      /* variante inexistente/indisponível: sem código e sem ?variant (nunca reaproveita a anterior) */
      ultimaVariante = d.variant ? d.variant : { id: 'nenhuma' };
      if (d.html) {
        var sec = document.getElementById('MainProduct-' + d.sectionId) || document;
        var atuais = sec.querySelectorAll('[data-es-por-variante]');
        var novos = d.html.querySelectorAll('[data-es-por-variante]');
        if (atuais.length === novos.length) atuais.forEach(function (el, i) { el.replaceWith(document.importNode(novos[i], true)); });
      }
      atualizarZap();
      Frete.linhaMudou();
      InfoPdp.variante(d.variant);
    });
  }

  /* ---------- busca no FAQ ---------- */
  function iniciarFaqBusca(input) {
    var alvo = document.getElementById(input.getAttribute('aria-controls'));
    if (!alvo) return;
    input.addEventListener('input', function () {
      var q = norm(input.value);
      $$('details', alvo).forEach(function (d) { d.hidden = q && norm(d.textContent).indexOf(q) === -1; });
      var vazio = $('[data-es-faq-vazio]', alvo.parentNode); if (vazio) vazio.hidden = !q || $$('details', alvo).some(function (d) { return !d.hidden; });
    });
  }

  function iniciar(raiz) {
    if (!raiz) veiculoDaUrl();
    raiz = raiz || document;
    iniciarValidade();
    $$('[data-es-carrossel]', raiz).forEach(iniciarCarrossel);
    iniciarVideos(raiz);
    $$('[data-es-contagem]', raiz).forEach(iniciarContagem);
    $$('[data-es-abas]', raiz).forEach(iniciarAbas);
    $$('[data-es-seletor]', raiz).forEach(iniciarSeletor);
    $$('[data-es-faq-busca]', raiz).forEach(iniciarFaqBusca);
    InfoPdp.iniciar(raiz);
    var chk = $('[data-es-filtro-veiculo] input[type="checkbox"]');
    if (chk && !chk.dataset.ligado) {
      chk.dataset.ligado = '1';
      chk.addEventListener('change', function () {
        Preferencia.salvar(chk.checked);
        definirParam('es_veiculo', chk.checked ? '1' : null);
        definirParam('es_p', null);
        Filtro.agendar();
      });
    }
    atualizarCards(); atualizarPdp();
    Frete.preparar(raiz); ligarCarrinho(); if (raiz === document) { Recomenda.executar(); RecPdp.executar(); }
    if (Filtro.pagina()) Filtro.agendar();
  }
  /* voltar/avançar com a página vinda do cache do navegador (bfcache) ou veículo alterado em outra aba:
     ressincroniza tudo com o armazenamento atual, para um veículo removido não reaparecer */
  function ressincronizar() {
    atualizarCards(); atualizarPdp(); RecPdp.executar();
    $$('[data-es-seletor]').forEach(function (s) { if (s._esPreencher) s._esPreencher(); });
    if (Filtro.pagina()) Filtro.agendar();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) ressincronizar(); });
  window.addEventListener('storage', function (e) { if (e.key === CHAVE || e.key === CHAVE_FILTRO) ressincronizar(); });
  /* troca de veículo: volta à 1ª página e refaz o conjunto */
  document.addEventListener('estocar:veiculo', function () {
    atualizarCards(); atualizarPdp(); RecPdp.executar();
    if (Filtro.pagina()) { definirParam('es_p', null); Filtro.agendar(); }
  });
  /* estocar.js é "defer": espera o DOMContentLoaded para que estocar-veiculos.js (também defer, mais abaixo) já tenha rodado */
  var iniciou = false;
  function uma() { if (iniciou) return; iniciou = true; iniciar(); }
  if (document.readyState === 'complete') uma(); else { document.addEventListener('DOMContentLoaded', uma); window.addEventListener('load', uma); }
  /* editor do tema: reinicia a seção alterada */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  /* Dawn troca a grade de produtos ao filtrar/paginar: reaplica selos */
  var agendado = false;
  var obs = new MutationObserver(function (mut) {
    var novaGrade = false, temCard = false;
    mut.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.id === 'product-grid' || n.querySelector('#product-grid')) novaGrade = true;
        if (n.matches('[data-es-aplic]') || n.querySelector('[data-es-aplic]')) temCard = true;
      });
    });
    /* o Dawn trocou a grade (filtro, ordenação, paginação dele): o original salvo ficou velho; refaz o conjunto */
    if (novaGrade) { Filtro.original = null; Filtro.agendar(); return; }
    if (!temCard || agendado) return;
    agendado = true;
    requestAnimationFrame(function () { agendado = false; atualizarCards(); });
  });
  ['ProductGridContainer', 'product-grid', 'ProductCount'].forEach(function (id) { var el = document.getElementById(id); if (el) obs.observe(el.parentNode || el, { childList: true, subtree: true }); });
})();
